export default __webpack_public_path__ + "static/banner_img-67730e8dbf27ff5563da3787ce94c01a.png";